import { render, staticRenderFns } from "./HostingMailingLists.vue?vue&type=template&id=17adc97e&"
import script from "./HostingMailingLists.vue?vue&type=script&lang=js&"
export * from "./HostingMailingLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports